export const updateCredentials = account => {
	return {
		type: 'UPDATECREDENTIALS',
		payload: {
			account: account
		}
	}
};